"use client";

import { c as _c } from "react/compiler-runtime";
import { useHeaderContext } from "@/contexts/HeaderContext";
import { useSearchParams } from "next/navigation";
import { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import { SIDEBAR_WIDTHS } from "../../constants/sidebar";
import { SidebarProvider } from "../../hooks/useSidebarState";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import SmallScreenHeader from "./SmallScreenHeader";
import WebSidebar from "./sidebar/WebSidebar";
interface Props {
  readonly children: ReactNode;
}
export default function SmallScreenLayout(t0) {
  const $ = _c(28);
  const {
    children
  } = t0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    registerRef
  } = useLayout();
  const {
    setHeaderRef
  } = useHeaderContext();
  const containerRef = useRef(null);
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("tab") || "latest";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeTab = t1;
  let t2;
  if ($[2] !== registerRef || $[3] !== setHeaderRef) {
    t2 = node => {
      registerRef("header", node);
      setHeaderRef(node);
    };
    $[2] = registerRef;
    $[3] = setHeaderRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const headerWrapperRef = t2;
  let t3;
  let t4;
  if ($[5] !== registerRef || $[6] !== setHeaderRef) {
    t3 = () => () => {
      registerRef("header", null);
      setHeaderRef(null);
    };
    t4 = [registerRef, setHeaderRef];
    $[5] = registerRef;
    $[6] = setHeaderRef;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[9] !== activeTab) {
    t5 = () => {
      const container = containerRef.current;
      if (container && activeTab) {
        requestAnimationFrame(() => {
          container.scrollTop = 0;
        });
      }
    };
    t6 = [activeTab];
    $[9] = activeTab;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsMenuOpen(_temp);
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const toggleMenu = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsMenuOpen(false);
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const closeMenu = t8;
  const t9 = `tw-bg-black ${activeTab === "feed" ? "tw-overflow-hidden" : "tw-overflow-auto"}`;
  let t10;
  if ($[14] !== isMenuOpen) {
    t10 = <SmallScreenHeader onMenuToggle={toggleMenu} isMenuOpen={isMenuOpen} />;
    $[14] = isMenuOpen;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== headerWrapperRef || $[17] !== t10) {
    t11 = <div ref={headerWrapperRef}>{t10}</div>;
    $[16] = headerWrapperRef;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isMenuOpen) {
    t12 = <div className="tailwind-scope"><WebSidebar isCollapsed={false} onToggle={toggleMenu} isMobile={true} isOffcanvasOpen={isMenuOpen} onCloseOffcanvas={closeMenu} sidebarWidth={SIDEBAR_WIDTHS.EXPANDED} /></div>;
    $[19] = isMenuOpen;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== children) {
    t13 = <main className="tw-transition-opacity tw-duration-300">{children}</main>;
    $[21] = children;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t12 || $[25] !== t13 || $[26] !== t9) {
    t14 = <SidebarProvider><div ref={containerRef} className={t9}>{t11}{t12}{t13}</div></SidebarProvider>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t9;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}
function _temp(prev) {
  return !prev;
}